import { render, staticRenderFns } from "./unit-performance.vue?vue&type=template&id=94995f96&scoped=true&"
import script from "./unit-performance.vue?vue&type=script&lang=js&"
export * from "./unit-performance.vue?vue&type=script&lang=js&"
import style0 from "./unit-performance.vue?vue&type=style&index=0&id=94995f96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94995f96",
  null
  
)

export default component.exports